import { useRouter } from "next/router";
import qs, { ParsedQs } from "qs";

export const getNormalisedParsedQuery = (path: string) => {
  return qs.parse(path.split("?")[1]);
};

export const getNormalisedUrl = (path: string, query: ParsedQs) => {
  const base = path.split("?")[0];
  return base + qs.stringify(query, { addQueryPrefix: true });
};

/**
 * Returns a path for Canvas destinations or a full URL for website destinations.
 *
 * Path is a string beginning with `/` that corresponds to a route at the destination.
 *
 * Query is stringified and appended to the path.
 */
export function useGetPathnameForDestination() {
  const router = useRouter();

  function getPathnameForDestination({
    destination = "canvas",
    path,
    query,
  }: {
    destination?: "canvas" | "website";
    path: string;
    query?: Record<string, unknown>;
  }): string {
    if (!path.startsWith("/")) {
      throw Error(`Path must begin with a "/" - received ${path}`);
    }

    if (destination === "canvas") {
      // Canvas destinations always need `/personalized-products/[...]` to trigger the proxy
      // and `router.query.solidus_slug` for the file-based routing
      return (
        (router.query.marketplace !== "us"
          ? `/${router.query.marketplace}`
          : "") +
        "/personalized-products/" +
        router.query.solidus_slug +
        path +
        qs.stringify(query, {
          addQueryPrefix: true,
        })
      );
    }

    // Website destinations can go straight to the `path`
    return (
      (router.query.marketplace !== "us"
        ? `/${router.query.marketplace}`
        : "") +
      path +
      qs.stringify(query, {
        addQueryPrefix: true,
      })
    );
  }

  return getPathnameForDestination;
}
